import { render } from "./Fx_Gains_Loss.vue?vue&type=template&id=04b94e00"
import script from "./Fx_Gains_Loss.vue?vue&type=script&lang=js"
export * from "./Fx_Gains_Loss.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__